export const MAX_TOP_TRADERS_TO_DISPLAY = 3;
